import React, { Fragment, useEffect, useRef } from 'react';
import ModalHeader from '@common-components/headers/ModalHeader';
import TicketCreateContainer from '@containers/individualPortal/ticket/TicketCreateContainer';
import { connect } from 'react-redux';

const CreateTicketModal = props => {
    const {
        environment,
        environment: {
            impersonation,
            impersonationDetails
        },
        modalHeaderProps,
        actions: {
            hideModal
        },
        boundAnchor,
        bottomAnchors: [
            anchor_1
        ],

    } = props;

    const handleCloseModal = () => hideModal();
    const replacements =  { replacements: impersonation ? `${impersonationDetails.name}` : `${environment.user.firstName} ${environment.user.lastName}` };
    const updatedModalHeaderProps = { ...modalHeaderProps, modalHeaderTextData: ['modals.header.create_ticket', replacements ] };

    return (
        <Fragment>
            <div className="gi-modal__header__head ">
                <ModalHeader {...{ ...updatedModalHeaderProps }} />
            </div>
            <div className="gi-modal__body create-ticket-modal">
                <TicketCreateContainer
                    handleCloseModal={handleCloseModal}
                    boundAnchor={boundAnchor}
                    anchor_1={anchor_1}
                />
            </div>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment,
});

export default connect(mapStateToProps)(CreateTicketModal);